import * as dashboardAction from './action';
const initialState = {
    dashboardData: [],
    portfolioFilters: [],
    checkDashboardData: [],
    checkDashboardDataFailure: [],
    counterpartiesDashboardData: [],
    getCaseCountDataByState: [],
    getCaseCountByStateFailure: []
}
const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {

        case dashboardAction.GET_DASHBOARD_DATA_SUCCESS:
            return state = {
                ...state,
                dashboardData: action.data,
                counterpartiesDashboardData: [...state.counterpartiesDashboardData, action.data]
            }
        case dashboardAction.GET_DASHBOARD_DATA_FAILURE:
            return state = {
                ...state,
                dashboardData: []
            }
        case dashboardAction.SET_FILTERS:
            return state = {
                ...state,
                portfolioFilters: action.data
            }
        case dashboardAction.CHECK_DASHBOARD_DATA_SUCCESS:
            return state = {
                ...state,
                checkDashboardData: action.data
            }
        case dashboardAction.CHECK_DASHBOARD_DATA_FAILURE:
            return state = {
                ...state,
                checkDashboardDataFailure: action.data
            }
        case dashboardAction.GET_CASE_COUNT_BY_STATE_SUCCESS:
            return state = {
                ...state,
                getCaseCountDataByState: action.data
            }
        case dashboardAction.GET_CASE_COUNT_BY_STATE_FAILURE:
            return state = {
                ...state,
                getCaseCountByStateFailure: action.data
            }
        default: return state
    }
}

export default dashboardReducer; 